import { createContext } from "react";

export const SimilarBasketsContext = createContext({
  similarBaskets: [],
  setSimilarBaskets: () => {},
  addSimilarBasket: () => {},
  removeSimilarBasket: () => {},
  resetSimilarBaskets: () => {}
});
